import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterOutlet } from '@angular/router';
import { ToastComponent } from './toast/toast.component';
import { BaseLoaderComponent } from '../app/modules/core-ui-component/base-loader/base-loader.component';
import { RunnerBridgeService } from './services/runner-bridge.service';

@Component({
    selector: 'app-root',
    imports: [CommonModule, RouterOutlet, ToastComponent, BaseLoaderComponent],
    template: `
    <app-toast key="global"></app-toast>
    <router-outlet></router-outlet>
    <app-base-loader></app-base-loader>
  `,
    styleUrls: ['./app.component.scss']
})
export class AppComponent {
  // Inject RunnerBridgeService to ensure it initializes and subscribes to runner events
  constructor(private _runnerBridge: RunnerBridgeService) {}
}
